import React, { FC } from "react";

import { font, lingerieUI, welcomeScreenUI } from "../../../../configs";
import { useIsMobile } from "../../../../utils";

type ButtonVariant = "focused" | "unfocused";

interface LingerieOptionButtonProps {
  id: string;
  label: string;
  selected: boolean;
  onSelect: () => void;
}

const btnSource = lingerieUI.questionCTA ?? welcomeScreenUI.genderCTA;

const getVariantStyles = (variant: ButtonVariant, isMobile: boolean) => ({
  width: "100%",
  backgroundColor: btnSource[variant].backgroundColor,
  borderRadius: btnSource[variant].borderRadius,
  borderColor: btnSource[variant].borderColor,
  borderWidth: btnSource[variant].borderWidth,
  fontSize: btnSource[variant].fontSize,
  fontWeight: btnSource[variant].fontWeight,
  textTransform:
    btnSource[variant].textTransform as React.CSSProperties["textTransform"],
  color: btnSource[variant].fontColor,
  fontFamily: isMobile
    ? `${font}, sans-serif`
    : `${font}, sans-serif !important`,
  letterSpacing: (btnSource[variant] as any)?.letterSpacing,
});

const LingerieOptionButton: FC<LingerieOptionButtonProps> = ({
  id,
  label,
  selected,
  onSelect,
}) => {
  const isMobile = useIsMobile();
  const styles = getVariantStyles(selected ? "focused" : "unfocused", isMobile);
  const textTransform =
    styles.textTransform === "capitalize" ? "none" : styles.textTransform;

  return (
    <button
      key={id}
      tabIndex={0}
      type="button"
      className={selected ? "selected" : ""}
      style={{ ...styles, textTransform }}
      onClick={onSelect}
    >
      {label}
    </button>
  );
};

export default LingerieOptionButton;
